module.exports = __webpack_public_path__ + "img/probuild.049f1b94.jpg";